import { cast, types } from 'mobx-state-tree';
const ResidentsUnit = types.model({
  fullname: types.string,
  unitName: types.string,
  residencyId: types.string,
  email: types.maybeNull(types.string),
  newEmail: types.maybeNull(types.string),
  billingStartDateOnly: types.optional(types.maybeNull(types.string), null),
  adminFee: types.optional(types.maybeNull(types.string), null)
});
export const ResidentsSetup = types.model({
  residents: types.optional(types.array(ResidentsUnit), []),
  residentsForm: types.optional(types.array(ResidentsUnit), [])
}).views(store => ({
  defaultAdminFee(id) {
    const idx = store.residentsForm.findIndex(i => i.residencyId === id);
    return store.residents[idx].adminFee;
  }
})).actions(store => ({
  setResidents(data, fees) {
    try {
      store.residents = cast([]);
      store.residentsForm = cast([]);
      data.map(i => {
        var _currentAdminFee$admi, _currentAdminFee$admi2, _currentAdminFee$admi3, _currentAdminFee$admi4, _currentAdminFee$admi5, _currentAdminFee$admi6;
        const currentAdminFee = fees.find(e => e.residencyId === i.residencyId);
        store.residents.push({
          email: i.email,
          fullname: i.fullname,
          unitName: i.unitName,
          newEmail: i.newEmail,
          adminFee: currentAdminFee !== null && currentAdminFee !== void 0 && (_currentAdminFee$admi = currentAdminFee.adminFee) !== null && _currentAdminFee$admi !== void 0 && _currentAdminFee$admi.value || (currentAdminFee === null || currentAdminFee === void 0 || (_currentAdminFee$admi2 = currentAdminFee.adminFee) === null || _currentAdminFee$admi2 === void 0 ? void 0 : _currentAdminFee$admi2.value) === 0 ? "".concat(currentAdminFee === null || currentAdminFee === void 0 || (_currentAdminFee$admi3 = currentAdminFee.adminFee) === null || _currentAdminFee$admi3 === void 0 ? void 0 : _currentAdminFee$admi3.value) : null,
          residencyId: i.residencyId,
          billingStartDateOnly: i.billingStartDateOnly
        });
        store.residentsForm.push({
          email: i.email,
          fullname: i.fullname,
          unitName: i.unitName,
          newEmail: i.newEmail,
          adminFee: currentAdminFee !== null && currentAdminFee !== void 0 && (_currentAdminFee$admi4 = currentAdminFee.adminFee) !== null && _currentAdminFee$admi4 !== void 0 && _currentAdminFee$admi4.value || (currentAdminFee === null || currentAdminFee === void 0 || (_currentAdminFee$admi5 = currentAdminFee.adminFee) === null || _currentAdminFee$admi5 === void 0 ? void 0 : _currentAdminFee$admi5.value) === 0 ? "".concat(currentAdminFee === null || currentAdminFee === void 0 || (_currentAdminFee$admi6 = currentAdminFee.adminFee) === null || _currentAdminFee$admi6 === void 0 ? void 0 : _currentAdminFee$admi6.value) : null,
          residencyId: i.residencyId,
          billingStartDateOnly: i.billingStartDateOnly
        });
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  changeBillingStartDateOnly(id, data) {
    try {
      const idx = store.residentsForm.findIndex(i => i.residencyId === id);
      store.residentsForm[idx].billingStartDateOnly = data;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  handleAdminFee(id, data) {
    try {
      const idx = store.residentsForm.findIndex(i => i.residencyId === id);
      store.residentsForm[idx].adminFee = data;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
}));